import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ServicesContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

export const ServicesHero = styled(motion.div)`
  position: relative;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  overflow: hidden;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    opacity: 0.9;
  }

  & > div {
    position: relative;
    z-index: 1;
  }
`;

export const ServicesGrid = styled(motion.div)`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 3rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    padding: 0 1rem;
    margin: 2rem auto;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const ServiceCard = styled(motion.div)`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-10px);
  }
  
  @media (max-width: 768px) {
    &:hover {
      transform: translateY(-5px);
    }
  }
`;

export const ServiceImage = styled.div`
  height: 250px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }
  
  &:hover img {
    transform: scale(1.1);
  }
`;

export const ServiceContent = styled.div`
  padding: 2rem;

  h3 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    color: #666;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 2rem;
  }

  li {
    padding: 0.5rem 0;
    color: #666;
    display: flex;
    align-items: center;
    
    &:before {
      content: "→";
      margin-right: 10px;
      color: #007bff;
    }
  }
`;


export const servicesData = [
  {
    id: 1,
    title: "Desarrollo Web Personalizado",
    description: "Creamos sitios web únicos que reflejan la identidad de tu marca y optimizan la experiencia del usuario.",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1500",
    features: ["Diseño Responsive", "SEO Optimizado", "Alto Rendimiento"]
  },
  {
    id: 2,
    title: "E-commerce Solutions",
    description: "Implementamos plataformas de comercio electrónico seguras, escalables y orientadas a convertir.",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1500",
    features: ["Pasarelas de Pago", "Gestión de Inventario", "Integración con Analytics"]
  },
  {
    id: 3,
    title: "Aplicaciones Web Progresivas",
    description: "Desarrollamos PWAs que funcionan en cualquier dispositivo y ofrecen una experiencia nativa.",
    image: "https://images.unsplash.com/photo-1555421689-491a97ff2040?auto=format&fit=crop&w=1500",
    features: ["Modo Offline", "Instalables", "Push Notifications"]
  },
  {
    id: 4,
    title: "Desarrollo de Apps Móviles",
    description: "Creamos aplicaciones móviles nativas y multiplataforma que conectan con tu audiencia desde la palma de su mano.",
    image: "https://images.pexels.com/photos/54284/pexels-photo-54284.jpeg?auto=compress&cs=tinysrgb&w=600",
    features: ["iOS & Android", "Publicación en stores", "UX/UI adaptado a móvil"]
  },
  {
    id: 5,
    title: "Posicionamiento SEO Avanzado",
    description: "Impulsamos tu presencia online con estrategias SEO técnicas, de contenido y de autoridad.",
    image: "https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&w=600",
    features: ["Auditoría SEO completa", "SEO On Page y Off Page", "Estrategia de contenidos"]
  },
  {
    id: 6,
    title: "Diseño Gráfico & Branding",
    description: "Diseñamos la imagen visual de tu marca desde cero o le damos un rebranding con personalidad.",
    image: "https://images.pexels.com/photos/31949740/pexels-photo-31949740/free-photo-of-tableta-digital-con-lapiz-optico-para-edicion-de-fotografias.jpeg?auto=compress&cs=tinysrgb&w=600",
    features: ["Identidad visual y logotipo", "Manual de marca", "Papelería corporativa"]
  },
  {
    id: 7,
    title: "Gestión de Redes Sociales",
    description: "Creamos y gestionamos tu presencia en redes con estrategia, contenido y campañas efectivas.",
    image: "https://images.pexels.com/photos/20041859/pexels-photo-20041859/free-photo-of-mujer-mano-telefono-inteligente-imagen.jpeg?auto=compress&cs=tinysrgb&w=600",
    features: ["Estrategia Social Media", "Diseño de publicaciones", "Publicidad en Meta y TikTok Ads"]
  },
  {
    id: 8,
    title: "Libro de Marca y Corporativismo",
    description: "Creamos tu guía visual y comunicacional para que tu marca tenga coherencia y fuerza en todos los canales.",
    image: "/libro_de_marca.png",
    features: ["Tipografía, colores y usos correctos", "Tonalidad de voz y estilo", "Aplicación en medios físicos y digitales"]
  }
];